import { firebaseApp } from "config/firebase/firebase";
import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import {
  Logout,
  getMenuClick,
  removeMenuClick,
  useGetMe,
  usePostMenuClick,
} from "service/auth";
import { IAppAuthContext } from "./interface";
import { getFirestore } from "firebase/firestore";
import { LoadingPage } from "components";
import dayjs from "config/dayjs";

const Context = React.createContext<IAppAuthContext>({} as IAppAuthContext);

const AppAuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useLocation();
  const isPublic = pathname === "/login";
  const { isLoading, data, isError } = useGetMe(isPublic);

  const storedData = getMenuClick();
  const storedDate = storedData?.recordDate;
  const dateNow = dayjs();
  const postMenuClickData = usePostMenuClick();

  useEffect(() => {
    if (storedDate) {
      const isAfter = dayjs(storedDate).isBefore(dateNow, "day");

      if (isAfter && !isPublic) {
        postMenuClickData.mutate(storedData, {
          onSuccess: () => {
            removeMenuClick();
          },
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading && !isPublic) {
    return (
      <div className="h-screen w-screen center">
        <LoadingPage />
      </div>
    );
  }
  if (isError && !isPublic) {
    return <Navigate to="/login" replace />;
  }
  if (data && !data?.role?.isActive) {
    Logout();
    return <Navigate to="/login" replace />;
  }

  const db = getFirestore(firebaseApp);

  return (
    <Context.Provider
      value={{ userMe: data, role: data?.role, firebaseApp, db }}
    >
      {children}
    </Context.Provider>
  );
};

export const useAppAuth = () => React.useContext(Context);
export default AppAuthProvider;
